export default __webpack_public_path__ + "static/media/member1.24b6f02b.jpg";